import PropTypes from 'prop-types';

export const AccountProps = PropTypes.shape({
  account_id: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  home_phone: PropTypes.string,
  email: PropTypes.string
});

export const AccountDefaults = {
  account_id: '',
  first_name: '',
  last_name: '',
  home_phone: '',
  email: ''
};
